<template>
  <div v-show="isShow.isPOShow" class="po">
    <div class="canvas-container"></div>
    <!-- <button class="start" @click="merge">触发</button> -->
    <div class="que-box" :class="transOut ? 'que-box-out' : ''">
      <div class="que">
        <div class="que-num">
          <div class="num" :class="`num${num}`" src="./img/num1.png"></div>
        </div>
        <div class="que-wp">
          <div class="que-real" :class="`que-real${num}`"></div>
          <div class="que-real-show" :class="[`que-real-show${num}`, resolved && isRight ? '' : 'hide']"></div>
        </div>
      </div>
      <div class="que-ans-wp">
        <div class="que-option-wp" :class="resolvedA ? 'resolved' : ''" @click="onChoose('a')">
          <div class="que-ans" :class="myAns[num]['a'] ? 'que-ans-right' : 'que-ans-wrong'">
            <div class="que-ans-opta que-ans-opt"></div>
            <div class="judge"></div>
          </div>
          <div class="que-entity">
            <div class="que-entity-ans" :class="`q${num}-opt-a`"></div>
            <div class="que-entity-right" :class="myAns[num]['a'] ? `que-entity-right${num}` : ''"></div>
          </div>
        </div>
        <div class="que-option-wp" :class="resolvedB ? 'resolved' : ''" @click="onChoose('b')">
          <div class="que-ans" :class="myAns[num]['b'] ? 'que-ans-right' : 'que-ans-wrong'">
            <div class="que-ans-optb que-ans-opt"></div>
            <div class="judge"></div>
          </div>
          <div class="que-entity">
            <div class="que-entity-ans" :class="`q${num}-opt-b`"></div>
            <div class="que-entity-right" :class="myAns[num]['b'] ? `que-entity-right${num}` : ''"></div>
          </div>
        </div>
        <div class="que-option-wp" :class="resolvedC ? 'resolved' : ''" @click="onChoose('c')">
          <div class="que-ans" :class="myAns[num]['c'] ? 'que-ans-right' : 'que-ans-wrong'">
            <div class="que-ans-optc que-ans-opt"></div>
            <div class="judge"></div>
          </div>
          <div class="que-entity">
            <div class="que-entity-ans" :class="`q${num}-opt-c`"></div>
            <div class="que-entity-right" :class="myAns[num]['c'] ? `que-entity-right${num}` : ''"></div>
          </div>
        </div>
        <div class="que-option-wp" :class="resolvedD ? 'resolved' : ''" @click="onChoose('d')">
          <div class="que-ans" :class="myAns[num]['d'] ? 'que-ans-right' : 'que-ans-wrong'">
            <div class="que-ans-optd que-ans-opt"></div>
            <div class="judge"></div>
          </div>
          <div class="que-entity">
            <div class="que-entity-ans" :class="`q${num}-opt-d`"></div>
            <div class="que-entity-right" :class="myAns[num]['d'] ? `que-entity-right${num}` : ''"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <img src="" alt="" class="temp"> -->
    <div class="pos-group">
      <img src="./img/merge-p1.jpg" id="pos-p1" alt="">
      <img src="./img/merge-p2.jpg" id="pos-p2" alt="">
      <img src="./img/merge-p3.jpg" id="pos-p3" alt="">
      <img src="./img/merge-p4.jpg" id="pos-p4" alt="">
      <img src="./img/merge-qr.png" id="pos-qr" alt="">
      <img src="./img/logo.png" alt="pos-logo" id="pos-logo">
    </div>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js';
import TWEEN from '@tweenjs/tween.js';
import { answers } from './answers.js';

let Application = PIXI.Application,
    loader = new PIXI.Loader(),
    Sprite = PIXI.Sprite;
let currentPos = {x: 0, y: 0};

export default {
  name: 'PageOne',
  props: {
    isShow: Object,
    name: String
  },
  data() {
    return {
      bg: null,
      bg2: null,
      bg3: null,
      num: 1,
      myAns: answers,
      resolved: false,
      resolvedA: false,
      resolvedB: false,
      resolvedC: false,
      resolvedD: false,
      transOut: true,
      isRight: false,
      gotScore: 0,
      tempSrc: null,
      isLock: false
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    'isShow.isPOShow': function () {
      setTimeout(() => {
        this.transOut = false;
      }, 300);
    }
  },
  methods: {
    merge() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const iP1 = document.getElementById('pos-p1');
      const iP2 = document.getElementById('pos-p2');
      const iP3 = document.getElementById('pos-p3');
      const iP4 = document.getElementById('pos-p4');
      const iQr = document.getElementById('pos-qr');
      let iPoster, iScore;

      if (this.gotScore === 9) {
        iPoster = iP1;
        iScore = 1;
      } else if (this.gotScore === 8) {
        iPoster = iP2;
        iScore = 2;
      } else if (this.gotScore === 7) {
        iPoster = iP3;
        iScore = 3;
      } else {
        iPoster = iP4;
        iScore = 4;
      }
      this.$emit('sendResult', iScore);
      ctx.width = canvas.width = 750;
      ctx.height = canvas.height = 1334;
      ctx.drawImage(iPoster, 0, 0, 750, 1334);
      ctx.drawImage(iQr, 550, 1150, 85, 85);
      // 添加文字
      ctx.fillStyle = '#e74445';
      ctx.textBaseline = 'top';
      ctx.font = '26px font-kt';
      // 第一行
      // ctx.fillText(this.name, 95, 1040);
      ctx.fillText(this.name, 95, 1040);
      ctx.beginPath();
      ctx.moveTo(95, 1070);
      ctx.lineWidth = 1;
      ctx.lineTo(95 + ctx.measureText(this.name).width, 1070);
      ctx.strokeStyle = '#e74445';
      ctx.stroke();

      ctx.fillStyle = '#666666';
      ctx.textBaseline = 'top';
      ctx.textAlign = 'center';
      ctx.font = '14px font-kt';
      ctx.fillText('扫码参与飞花令', 592, 1240);

      ctx.font = '24px font-kt';
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const txt = `${year}年${month}月${day}日`;

      ctx.fillText(txt, 410, 1170);
      const img = canvas.toDataURL();
      setTimeout(() => {
        this.$emit('sendImg', img);
        // document.querySelector('.temp').src = img
      }, 400);
    },
    resetState() {
      this.resolved = false;
      this.resolvedA = false;
      this.resolvedB = false;
      this.resolvedC = false;
      this.resolvedD = false;
      this.isRight = false;
    },
    onChoose(param) {
      if (!this.isLock) {
        if (this.myAns[this.num][param]) {
          this.gotScore += 1;
        }
        this.isRight = this.myAns[this.num][param];
        this.resolved = true;
        this.$emit('playAudio', this.num);
        setTimeout(() => {
          this.transOut = true;
          this.resetState();
          setTimeout(() => {
            if (this.num === 9) {
              this.merge();
              this.showNext();
            } else {
              this.triggerAni();
            }
          }, 300);
        }, 6000);
        setTimeout(() => {
          this.transOut = false;
          this.isLock = false;
        }, 9000);
        switch (param) {
          case 'a':
            this.resolvedA = true;
            break;
          case 'b':
            this.resolvedB = true;
            break;
          case 'c':
            this.resolvedC = true;
            break;
          case 'd':
            this.resolvedD = true;
            break;
          default:
            break;
        }
      }
      this.isLock = true;
    },
    showNext () {
      this.$emit('nextPage', 'isPTShow');
    },
    triggerAni() {
      this.tweenAni(this.num);
      this.num += 1;
      if (this.num === 4) {
        new TWEEN.Tween({scale: 1})
          .to({scale: 4}, 2000)
          .easing(TWEEN.Easing.Exponential.In)
          .onUpdate((obj) => {this.yard.scale.set(obj.scale, obj.scale)})
          .onComplete(() => {
            this.yard.alpha = 0;
            this.app.stage.addChild(this.bg2);
          })
          .start()
      } else if (this.num === 5) {
        this.yard.alpha = 1;
        this.app.stage.removeChild(this.bg2);
        const t1 = new TWEEN.Tween({scale: 4})
          .to({scale: 1}, 1000)
          .easing(TWEEN.Easing.Linear.None)
          .onUpdate((obj) => this.yard.scale.set(obj.scale, obj.scale))
          .onComplete(() => {
          })

        const t2 = new TWEEN.Tween(currentPos)
          .to({x:-2070, y:-1710}, 1000)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate((obj) => {this.bg.position.set(obj.x, obj.y)})
          .onComplete((obj) => {
            currentPos = {x: obj.x, y: obj.y}
          })
        t1.chain(t2).start();
      } else if (this.num === 7) {
        new TWEEN.Tween({scale: 1})
          .to({scale: 4}, 2000)
          .easing(TWEEN.Easing.Exponential.In)
          .onUpdate((obj) => {this.bg.scale.set(obj.scale, obj.scale)})
          .onComplete(() => {
            this.bg.alpha = 0;
            this.app.stage.addChild(this.bg3);
          })
          .start()
      } else if (this.num === 8) {
        new TWEEN.Tween({x: 0, y: 0})
          .to({x: -940, y: 0}, 2000)
          .easing(TWEEN.Easing.Sinusoidal.Out)
          .onUpdate((obj) => {this.bg3.position.set(obj.x, obj.y)})
          .onComplete((obj) => {
            currentPos = {x: obj.x, y: obj.y};
          })
          .start()
      } else if (this.num === 9) {
        this.bg.alpha = 1;
        this.app.stage.removeChild(this.bg3);
        new TWEEN.Tween({scale: 4, x:0, y:0})
          .to({scale: 1, x:0, y:-1894}, 2000)
          .easing(TWEEN.Easing.Sinusoidal.In)
          .onUpdate((obj) => {
            this.bg.scale.set(obj.scale, obj.scale);
            this.bg.position.set(obj.x, obj.y)
          })
          .onComplete((obj) => {
            currentPos = {x: obj.x, y: obj.y}
          })
          .start()
      }
    },
    init() {
      let app = new Application({ 
        width: 750,
        height: 1470,
        backgroundColor: 0x32A56E,                
        antialias: true,
        transparent: false, 
        resolution: 1
      });

      loader.add('bg', require('./img/bg.jpg'))
        .add('bg2', require('./img/bg2.jpg'))
        .add('bg3', require('./img/bg3.jpg'))
        .add('yard', require('./img/yard.png'))
        .on('progress', loadProgressHandler)
        .load(setup)
      
      const container = document.querySelector('.canvas-container');
      container.appendChild(app.view);

      function loadProgressHandler() {
        // console.log("loading: " + resource.url); 
        // console.log("progress: " + loader.progress + "%"); 
      }

      let bg, bg2, bg3, yard;
      const self = this;
      function setup(loader, resources) {
        bg = new Sprite(resources["bg"].texture),
        bg2 = new Sprite(resources["bg2"].texture),
        bg3 = new Sprite(resources["bg3"].texture)
        yard = new Sprite(resources["yard"].texture);
        self.bg = bg;
        self.bg2 = bg2;
        self.bg3 = bg3;
        self.yard = yard;
        self.app = app;
        
        bg.position.set(currentPos.x, currentPos.y);
        yard.anchor.set(1, 0);
        yard.position.set(2825, 455);
        bg.addChild(yard);
        app.stage.addChild(bg);
        app.ticker.add(delta => gameLoop(delta))
      }

      function gameLoop() {
        TWEEN.update();
      }
    },
    tweenAni(num) {
      let position = {
        1: {x: -1125, y: -1894},
        2: {x: -2070, y: -20},
        5: {x: -960, y: 0},
        9: {x: 0, y: -1894}
      }
      let tween;
      if (num === 3 || num === 4 || num === 6 || num === 7) {
        // ..
      } else {
        tween = this.createTween(currentPos, position[num], 2000, TWEEN.Easing.Quadratic.InOut)
        tween.start();
      }
    },
    createTween(p1 = {x: 0, y: 0}, p2 = {x:-250, y:-600}, time = 1000, easing = TWEEN.Easing.Quadratic.InOut, spr = [this.bg]) {
      const tween = new TWEEN.Tween(p1)
        .to(p2, time)
        .onUpdate((obj) => {
          spr.map((s) => {
            s.position.set(obj.x, obj.y)
          })
        })
        .onComplete((obj) => {
          currentPos = {x: obj.x, y: obj.y};
        })
        .easing(easing)
      return tween;
    }    
  }
}
</script>

<style lang="less" scoped>
@import url('./opt.less');

.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.po {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: lightcyan;
  overflow: hidden;
}
.que-box {
  position: absolute;
  margin-bottom: 2rem;
  transition: all .3s;
}
.que-box-out {
  transform: scale(.8);
  opacity: 0;
}
.que {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 2.5/2rem /* 40/16 */ 3.125/2rem /* 50/16 */ 0;
  height: 11.875/2rem /* 190/16 */;
  width: 43.125/2rem /* 690/16 */;
  background:
    radial-gradient(circle at bottom right, transparent 15px, white 0) bottom right,
    radial-gradient(circle at bottom left, transparent 15px, white 0) bottom left;
  background-size: 52% 100%;
  background-repeat: no-repeat;
  border-radius: 20px;
  box-shadow: 0 -10px 10px -8px rgba(0, 0, 0, .2);
}
.que-ans-wp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
  padding: 4.375/2rem /* 70/16 */ 2.5/2rem /* 40/16 */ 2rem;
  margin-top: .625/2rem /* 10/16 */;
  width: 43.125/2rem /* 690/16 */;
  height: 39.375/2rem /* 630/16 */;
  background:
    radial-gradient(circle at top right, transparent 15px, white 0) top right,
    radial-gradient(circle at top left, transparent 15px, white 0) top left;
  background-size: 52% 100%;
  background-repeat: no-repeat;
  border-radius: 20px; 
  box-shadow: 0 10px 10px -8px rgba(0, 0, 0, .2);
  &::after {
    position: absolute;
    content: '';
    bottom: 0;
    left: 0;
    width: 43.125/2rem /* 690/16 */;
    height: 13.375/2rem /* 214/16 */;
    background-image: url('./img/option-box-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
}
.que-num {
  width: 5.5625/2rem /* 89/16 */;
  height: 2/2rem /* 32/16 */;
}
.num {
  width: 5.5625/2rem /* 89/16 */;
  height: 2/2rem /* 32/16 */;
}
.que-wp {
  position: relative;
  width: 26.875/2rem /* 430/16 */;
  height: 8.75/2rem /* 140/16 */;
}
.que-real, .que-real-show {
  position: absolute;
  left: 0;
  top: 0;
  width: 26.875/2rem /* 430/16 */;
  height: 8.75/2rem /* 140/16 */;
}
.que-real-show {
  transition: opacity .3s;
}
.que-option-wp {
  display: flex;
  z-index: 3;
}
.que-ans {
  margin-right: 1rem;
  .que-ans-opt {
    margin: 0 auto;
    width: 2.125/2rem /* 34/16 */;
    height: 1.8125/2rem /* 29/16 */;
  }
  .que-ans-opta {
    .bg('./img/option-a.png');
  }
  .que-ans-optb {
    .bg('./img/option-b.png');
  }
  .que-ans-optc {
    .bg('./img/option-c.png');
  }
  .que-ans-optd {
    .bg('./img/option-d.png');
  }
}
.resolved {
  .que-ans-right {
    .judge {
      opacity: 1;
    }
  }
}
.que-ans-right {
  .judge {
    opacity: 0;
    margin-top: 1rem;
    width: 3.125/2rem /* 50/16 */;
    height: 3.125/2rem /* 50/16 */;
    .bg('./img/tick.png');
    transition: opacity .3s;
  }
}
.resolved {
  .que-ans-wrong {
    .judge {
      opacity: 1;
    }
  }
}
.que-ans-wrong {
  .judge {
    opacity: 0;
    margin-top: 1rem;
    width: 3.125/2rem /* 50/16 */;
    height: 3.125/2rem /* 50/16 */;
    .bg('./img/cross.png');
    transition: opacity .3s;
  }
}

.que-entity {
  position: relative;
  width: 12.5/2rem /* 200/16 */;
  height: 13.625/2rem /* 218/16 */;
  .bg('./img/option-box.png');
  background-size: 100% 100%;
}
.que-entity-ans, .que-entity-right {
  position: absolute;
  left: 50%;
  top: .35rem;
  margin-left: -11.125/4rem /* 178/16 */;
  width: 11.125/2rem /* 178/16 */;
  height: 11.125/2rem /* 178/16 */;
}
.que-entity-right {
  opacity: 0;
  transition: opacity .3s;
}
.resolved {
  .que-entity-right {
    opacity: 1;
  }
}
.que-entity-right1 {
  .bg('./img/1.gif');
  background-size: 100% 100%;
}
.que-entity-right2 {
  .bg('./img/2.gif');
  background-size: 100% 100%;
}
.que-entity-right3 {
  .bg('./img/3.gif');
  background-size: 100% 100%;
}
.que-entity-right4 {
  .bg('./img/4.gif');
  background-size: 100% 100%;
}
.que-entity-right5 {
  .bg('./img/5.gif');
  background-size: 100% 100%;
}
.que-entity-right6 {
  .bg('./img/6.gif');
  background-size: 100% 100%;
}
.que-entity-right7 {
  .bg('./img/7.gif');
  background-size: 100% 100%;
}
.que-entity-right8 {
  .bg('./img/8.gif');
  background-size: 100% 100%;
}
.que-entity-right9 {
  .bg('./img/9.gif');
  background-size: 100% 100%;
}
.hide {
  opacity: 0;
  background-size: contain;
}

.start {
  position: absolute;
  left: 50%;
  top: 30px;
  margin-left: -34px;
  padding: 8px 14px;
  outline: none;
  border: none;
  background-color: transparent;
  border: 1px solid grey;
  border-radius: 4px;
  color: grey;
  &:active {
    opacity: .6;
  }
}
.pos-group {
  display: none;
}
// .queIn {
//   animation: queIn .3s ease forwards;
// }
// @keyframes queIn {
//   from {
//     opacity: 0;
//     transform: scale(.8);
//   }
//   to {
//     opacity: 1;
//     transform: scale(1);
//   }
// }
</style>
